import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();
  const { lang } = useLanguage();

  const homeLabel = {
    telugu: 'ముఖపేజీ',
    sanskrit: 'मुखपृष्ठम्'
  };

  return (
    <Box sx={{ mb: 3, mt: 2 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          '& .MuiBreadcrumbs-separator': {
            color: '#7f4b2d'
          }
        }}
      >
        <Link
          underline="hover"
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: '#7f4b2d',
            cursor: 'pointer',
            '&:hover': {
              color: '#b06b3a'
            }
          }}
          onClick={() => navigate('/')}
        >
          <HomeIcon sx={{ mr: 0.5, fontSize: '20px' }} />
          {homeLabel[lang]}
        </Link>
        
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          if (isLast) {
            return (
              <Typography
                key={index}
                sx={{
                  color: '#555',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {item.label}
              </Typography>
            );
          }
          
          return (
            <Link
              key={index}
              underline="hover"
              sx={{
                color: '#7f4b2d',
                cursor: 'pointer',
                '&:hover': {
                  color: '#b06b3a'
                }
              }}
              onClick={() => item.path && navigate(item.path)}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
